<template>
    <div>
        <div class="modal hide fade" id="modalGetProductPurchasing" tabindex="-1" role="dialog" aria-labelledby="modalGetProductPurchasing" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Product</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="dl-custom row">
                                    <dt class="col-md-4">Active</dt>
                                    <dd class="col-md-8">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" id="active" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="product.active">
                                            <label for="active" class="custom-control-label">Active</label>
                                        </div>
                                    </dd>
                                    <dt class="col-md-4">Product No.</dt>
                                    <dd class="col-md-8">{{ product.product_no}}</dd>
                                    <dt class="col-md-4">Name</dt>
                                    <dd class="col-md-8">{{ product.product_name}}</dd>
                                    <dt class="col-md-4">Type</dt>
                                    <dd class="col-md-8">{{ product.type}}</dd>
                                    <dt class="col-md-4">Category</dt>
                                    <dd class="col-md-8">{{ product.category}}</dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-sm btn-soft-primary" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { productUrl, getHeader } from '@/config'
import { mapState } from 'vuex'
export default {
  name: 'ProductShowModal',
  computed: {
    ...mapState({
      product: state => state.products.product
    })
  },
  methods: {
    async save () {
      await axios.put(productUrl + '/set-active/' + this.product.id, this.product, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$emit('backRefresh')
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>
